import { VALTYPE_ANY, VALTYPES } from '../../../data/interfaces';
import ParamSet from '../edit-etl-component/ParamSet';
import { addETLDryRunError } from '../etlDryRun';
import {
  TpAggregationInstance,
  TpETLAggregationCustomParamRenderContext,
  TpETLAggregationDryRunContext,
  TpETLAggregationType,
} from './interfaces';

const aggConcat: TpETLAggregationType = {
  id: 'concat',
  name: 'Concatenate',
  description: 'Returns a string that concatenates all source content.',
  compatibleInputDataTypes: VALTYPE_ANY,
  outputDataType: VALTYPES.STRING,
  getAggName: (agg: TpAggregationInstance) => {
    return aggConcat.name;
  },
  performDryRun: (ctx: TpETLAggregationDryRunContext) => {},
};

const aggDistinctList: TpETLAggregationType = {
  id: 'distinctList',
  name: 'Distinct values list',
  description: 'Returns a list of all the distinct values in the source column.',
  compatibleInputDataTypes: [VALTYPES.STRING, VALTYPES.MULTISTRING, VALTYPES.CATEGORICAL, VALTYPES.MULTICAT],
  outputDataType: null,
  getAggName: (agg: TpAggregationInstance) => {
    return aggDistinctList.name;
  },
  performDryRun: (ctx: TpETLAggregationDryRunContext) => {},
};

const aggAverage: TpETLAggregationType = {
  id: 'average',
  name: 'Average',
  description: 'Computes the average of a set of numerical values',
  compatibleInputDataTypes: [VALTYPES.NUMBER],
  outputDataType: VALTYPES.NUMBER,
  getAggName: (agg: TpAggregationInstance) => {
    return aggAverage.name;
  },
  performDryRun: (ctx: TpETLAggregationDryRunContext) => {},
};

const aggSum: TpETLAggregationType = {
  id: 'sum',
  name: 'Sum',
  description: 'Computes the sum of a set of numerical values',
  compatibleInputDataTypes: [VALTYPES.NUMBER],
  outputDataType: VALTYPES.NUMBER,
  getAggName: (agg: TpAggregationInstance) => {
    return aggSum.name;
  },
  performDryRun: (ctx: TpETLAggregationDryRunContext) => {},
};

const aggPercentile: TpETLAggregationType = {
  id: 'percentile',
  name: 'Percentile',
  description: 'Computes a preset percentile of a set of numerical values',
  compatibleInputDataTypes: [VALTYPES.NUMBER],
  outputDataType: VALTYPES.NUMBER,
  defaultCustomParams: { percentile: 50 },
  getAggName: (agg: TpAggregationInstance) => {
    return `${agg.params.percentile} percentile`;
  },
  renderCustomParams: (ctx: TpETLAggregationCustomParamRenderContext) => {
    return (
      <ParamSet
        params={[
          {
            name: 'Percentiles',
            component: (
              <input
                type="number"
                value={
                  !!ctx.agg.params && 'percentile' in ctx.agg.params
                    ? ctx.agg.params['percentile']
                    : aggPercentile.defaultCustomParams!['percentile']
                }
                onChange={(ev) => {
                  ctx.updateAggregationParam('percentile', ev.target.value);
                }}
              />
            ),
          },
        ]}
      />
    );
  },
  performDryRun: (ctx: TpETLAggregationDryRunContext) => {
    const percentile = ctx.agg.params['percentile'];
    if (percentile < 0 || percentile > 100)
      addETLDryRunError(ctx.dryRun, `Percentile should be in the range 0-100`, ctx.comp.id, ctx.agg.id);
  },
};

// The list of all available aggregation types
// for now leave out aggCAGRVariable
export const aggregationTypesList = [aggConcat, aggDistinctList, aggAverage, aggSum, aggPercentile];

const aggregationTypesMap: { [id: string]: TpETLAggregationType } = {};

for (const agg of aggregationTypesList) aggregationTypesMap[agg.id] = agg;

export function getAggregationTypeInfo(aggType: string) {
  if (!aggregationTypesMap[aggType]) {
    debugger;
    throw `Invalid aggregation type: ${aggType}`;
  }
  return aggregationTypesMap[aggType];
}

export const defaultAggregationType = aggConcat;

export function aggregationHasCompatibleSourceColumn(aggTypeId: string, sourceDataType: string): boolean {
  const aggType = getAggregationTypeInfo(aggTypeId);
  if (aggType.compatibleInputDataTypes == VALTYPE_ANY) return true;
  return aggType.compatibleInputDataTypes.includes(sourceDataType);
}
